module.exports = __webpack_public_path__ + "img/swiper6.32cc2705.png";